import React, { useState, useEffect } from "react";
import { Button, Form, Modal, Popconfirm, Row, Col, Tree, Input } from "antd";
import service from "../../../services/citizenScienceLookupService";
import { recordError } from "../../../utils/logService";

import {
  Notify,
  openNotification,
  util
} from '@seims/shared';

const EditTargetBeneficiaries = ({
  beneficiaryData,
  visible,
  onCancel,
  onModalSubmit,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [targetBeneficiaries, setTargetBeneficiaries] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [parentIds, setParentIds] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  // const [showOther, setShowOther] = useState(false);
  const [dataKeys, setDataKeys] = useState([]);
  const [defaultKeys, setDefaultKeys] = useState([]);
  const [defaultOtherVal, setDefaultOtherVal] = useState("");

  const [form] = Form.useForm();
  const formName = "EditTargetBeneficiariesForm";
  var beneficiaryErrorMsg =
    "Please select at least one beneficiary option/sub-option";

  useEffect(() => {
    getTargetBeneficiaries();
  }, []);

  useEffect(() => {
    loadProjectData();
  }, [expandedKeys, beneficiaryData?.projectProfile]);

  const getTargetBeneficiaries = async () => {
    try {
      const response = await service.getBeneficiaries();

      if (response && response.status === 200) {
        const { data } = response;
        const transData = transformData(data);
        const childNodes = collectChildKeys(transData);

        setTreeData(transData);
        const parentIdNodes = transData.map((node) => node.key);
        setParentIds(parentIdNodes);
        setExpandedKeys(childNodes);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const transformData = (data, isLeaf = false) => {
    return data.map((item) => ({
      key: item.key,
      title: item.value,
      isleaf: isLeaf,
      parentKey: item.key,
      children: item.children
        ? transformData(item.children, (isLeaf = true), { parentKey: item.key })
        : [],
    }));
  };

  const onExpand = (expandedKeysValue) => {
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onSelect = (selectedKeysValue, info) => {
    setSelectedKeys(selectedKeysValue);
  };

  const collectChildKeys = (nodes) => {
    let keys = [];

    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => keys.push(child.key.toString()));

        //? Line below is cateriing for inner child nodes
        keys = keys.concat(collectChildKeys(node.children));
      }
    });

    return keys;
  };

  const onNameBlur = (e) => {
    // const { value, name } = e.target;
    // const textValue = util.toPascalText(value);
    // form.setFieldsValue({ [name]: textValue });
  };

  const onPopCancel = () => {
    onCancel();
    setDisabled(true);
    // form.resetFields();
  };

  const Confirm = () => {
    onCancel();
    form.resetFields();
  };

  const loadProjectData = () => {
    var rData = populateTree(beneficiaryData.beneficiaries);
    const preSelected = treeData?.filter((c) => rData?.includes(c.key));

    let dKeys = [];
    var impact = beneficiaryData.beneficiaries.forEach((ben) =>

      ben?.impact?.forEach((imp) => {
        dKeys.push({
          key: imp.key,
          parentId: ben.key,
          title: ben.value
        })
      })
    );
    setDataKeys(dKeys);
    
    var tData = transformData(preSelected, false);

    // const findOtherOption = treeData?.find(
    //   (c) => c.title?.toLowerCase() === "other"
    // );

    // if (preSelected.find((c) => c.title?.toLowerCase() === "other")) {
    //   setShowOther(true);
    //   setDefaultOtherVal(beneficiaryData?.projectProfile?.otherBeneficiary);
    // } else {
    //   setShowOther(false);
    //   form.resetFields(["otherBeneficiary"]);
    // }

    // if (data.projectProfile !== undefined) {
    // form.setFieldsValue({"otherBeneficiary": data.projectProfile.otherBeneficiary});
    // }
    // setSelected([]);
    setCheckedKeys(rData);
    form.setFieldsValue({
      beneficiaries: preSelected,
      // otherBeneficiary: beneficiaryData?.projectProfile?.otherBeneficiary,
      // other: "TESTING",
    });
  };

  const populateTree = (treeData) => {
    var dd = [];
    var children = [];
    treeData.forEach((data) => {
      data?.impact?.forEach((chn) => {
        children.push(chn.key);
      });
      dd.push(data.key);
      children.forEach((ch) => {
        dd.push(ch);
      });
    });
    return dd;
  };

  const onCheck = (checkedKeysValue, info) => {
    const beneficiaries = [];
    let newSelected = [...selected];
    setDataKeys([]);
    checkedKeysValue.forEach((value) => {
      var pKey = findParentByChildKey(value);
      if (pKey !== null) {
        var node = {
          key: value,
          parentId: pKey.key,
          title: pKey.title,
        };
        beneficiaries.push(node);
      }
    });
    setDataKeys(beneficiaries);

    if (checkedKeysValue.length === 0) {
      setSelected([]);
      setCheckedKeys(checkedKeysValue);
      form.setFieldsValue({ beneficiaries: checkedKeysValue });
      return;
    }

    for (const node of info.checkedNodes) {
      const selectedItem = node.key;

      if (parentIds.includes(selectedItem)) {
        const foundParentKeys = treeData
          .find((c) => c.key === selectedItem)
          .children.map((c) => c.key);

        const impact = checkedKeysValue.filter(
          (child) =>
            !parentIds.includes(child) && foundParentKeys.includes(child)
        );
        const exists = newSelected.find((c) => c.type === selectedItem);
        if (!exists) {
          beneficiaries.push({ type: selectedItem, impact });
          newSelected.push({ type: selectedItem, impact });
        } else {
          exists.impact = impact;
        }
      } else {
        const parent = findParentByChildKey(selectedItem);

        if (parent) {
          let parentEntry = newSelected.find((c) => c.type === parent.key);
          if (parentEntry) {
            // Ensure that the selected items aer added that are not already in impact
            parentEntry.impact = parentEntry.impact.filter((impactItem) =>
              checkedKeysValue.includes(impactItem)
            );
            if (!parentEntry.impact.includes(selectedItem)) {
              parentEntry.impact.push(selectedItem);
            }
          } else {
            parentEntry = { type: parent.key, impact: [selectedItem] };
            newSelected.push(parentEntry);
          }
        }
      }

      // Checking for duplicates that might have been added during adding process
      newSelected = newSelected
        .map((entry) => {
          entry.impact = entry.impact.filter((impactItem) =>
            checkedKeysValue.includes(impactItem)
          );
          return entry;
        })
        .filter((entry) => entry.impact.length > 0);

      setSelected(newSelected);
      setCheckedKeys(checkedKeysValue);
      form.setFieldsValue({ beneficiaries: checkedKeysValue });

      // const findOtherOption = treeData.find((c) => c.key === selectedItem);

      // if (findOtherOption?.title === "Other") {
      //   setShowOther(true);
      // } else {
      //   setShowOther(false);
      //   //   form.resetFields(["otherBeneficiary"]);
      // }
    }

    setSelected(newSelected);

    setCheckedKeys(checkedKeysValue);
    form.setFieldsValue({ beneficiaries: checkedKeysValue });

    setTargetBeneficiaries(newSelected);

    if (checkedKeysValue.length > 0) {
      form.setFields([
        {
          name: "beneficiaries",
          parent: checkedKeysValue,
          value: checkedKeysValue,
          errors: [],
        },
      ]);
    } else {
      form.setFields([
        {
          name: "beneficiaries",
          value: [],
          errors: [beneficiaryErrorMsg],
        },
      ]);
    }
  };

  const findParentByChildKey = (targetKey) => {
    for (let node of treeData) {
      if (
        node.children &&
        node.children.some((child) => child.key === targetKey)
      ) {
        return node;
      }
    }
    return null;
  };

  const onSubmit = async (values) => {
    var otherOption;
    const preSelected = treeData?.filter((c) =>
      values?.beneficiaries?.includes(c.key)
    );
    // const selectedOtherOptions = preSelected?.filter((c) => c.title?.toLowerCase() === 'other')
    // if (selectedOtherOptions.length > 0) {
    //   otherOption = selectedOtherOptions.map(c => ({
    //     type: c.key, impact: []
    //   }))
    // }
    try {
      var parentKeys = [];
      var impact = [];
      var returnedData = [];
      var parentTitle = "";
      const uniqueParentIds = dataKeys.reduce((acc, obj) => {
        if (!acc.includes(obj.parentId)) {
          if (obj.parentId !== undefined) acc.push(obj.parentId);
        }
        return acc;
      }, []);
      uniqueParentIds.forEach((parentId) => {
        var treeChildren = treeData.filter((c) => c.parentKey === parentId);
        var chd = [];
        var d = dataKeys.filter((dKey) => dKey.parentId === parentId);
        if (d.length > 0) {
          d.forEach((sd) => {
            parentTitle = sd.title;
            var td = treeChildren.filter((dd) => dd.parentKey === sd.parentId);
            const childs = td.map((x) => x.children);
            childs.forEach((cc) => {
              const ch = cc.find((x) => x.key === sd.key);
              if (ch !== undefined) {
                chd.push({
                  key: ch.key,
                  title: ch.title,
                  parentKey: parentId,
                });
                impact.push(sd.key);
              }
            });
          });
        }
        returnedData.push({
          key: parentId,
          parentKey: parentId,
          title: parentTitle,
          children: chd,
          impact: impact,
        });
        impact = [];
      });

      dataKeys.forEach((value) => {
        if (!parentKeys.includes(value.parentId)) {
          var d = treeData.find(
            (dKey) => dKey.parentKey === parseInt(value.parentId)
          );
          if (d !== undefined) {
            parentKeys.push({
              key: value.parentId,
              title: d.title === undefined ? "" : d.title,
            });
          }
        }
      });
      var beneData = [];
      var returnData = [];
      returnedData.forEach((value) => {
        beneData.push({ type: value.key, impact: value.impact });
        returnData.push({
          key: value.key,
          title: value.title,
          parentKey: value.parentKey,
          children: value.children,
        });
      });

      // if (otherOption !== undefined) {
      //   if (otherOption.length > 0) {
      //     beneData.push(otherOption[0]);
      //   }
      // }

      if (returnData.length === 0) {
        openNotification(
          "Target Beneficiary",
          beneficiaryErrorMsg,
          Notify.ERROR
        );
        return;
      }
      onModalSubmit(beneData, returnData, values.otherBeneficiary);
    } catch (error) {
      recordError(error);
    }
  };

  return (
    <Modal
      title={"Target Beneficiaries - Edit"}
      onCancel={onCancel}
      open={visible}
      maskClosable={false}
      closable={false}
      keyboard={false}
      onOk={() =>
        form
          .validateFields()
          .then((res) => {
            form.resetFields();
            onSubmit(res);
          })
          .catch((error) => {
            recordError(error);
          })
      }
      footer={[
        <div key="modal-footer-buttons" className="modal-footer-buttons">
          <Popconfirm
            key="2"
            title="Are you sure you want to cancel...you will lose all info entered?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => Confirm()}
            onCancel={onPopCancel}
            disabled={disabled}
          >
            <Button onMouseUp={() => onPopCancel()} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Popconfirm>
          <Button
            key="1"
            type="primary"
            htmlType="submit"
            onSubmit={onSubmit}
            form={formName}
          >
            Save
          </Button>
        </div>,
      ]}
    >
      <Form layout="vertical" name={formName} form={form} onFinish={onSubmit}>
        <>
          <Form.Item
            name="beneficiaries"
            label="Target Beneficiaries"
            key="beneficiaries"
          >
            <Tree
              checkable
              onCheck={onCheck}
              checkedKeys={checkedKeys}
              treeData={treeData}
              onExpand={onExpand}
              expandedKeys={expandedKeys}
              autoExpandParent={autoExpandParent}
              onSelect={onSelect}
              selectedKeys={selectedKeys}
              defaultCheckedKeys={defaultKeys}
            />
          </Form.Item>

          {/* {showOther && (
            <Form.Item
              name="otherBeneficiary"
              label="Other Beneficiary"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please provide other beneficiary",
            //   },
            // ]}
            >
              <Input name="otherBeneficiary" onBlur={onNameBlur} />
            </Form.Item>
          )} */}
        </>
      </Form>
    </Modal>
  );
};

export default EditTargetBeneficiaries;
